import { CookieService } from 'ngx-cookie-service';

export interface IExtendedCookieService extends CookieService {}
